import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import Link from "next/link";
import type React from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => (
	<VendorLayoutV2>
		<VendorSettingLayout>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: PATH, label: "設定一覧" },
						{ label: "プロフィール詳細" }
					]}
				/>
			</div>
			<ProfileSetting />
		</VendorSettingLayout>
	</VendorLayoutV2>
);
